import * as actionTypes from './actionTypes';

export const connectRequest = (payload) => ({ type: actionTypes.INTEGRATIONS_CONNECT_REQUEST, payload });
export const connectFailed = (payload) => ({ type: actionTypes.INTEGRATIONS_CONNECT_FAILED, payload });
export const connectSucceed = (payload) => ({ type: actionTypes.INTEGRATIONS_CONNECT_SUCCEED, payload });

export const getConnectedIntegrationsRequest = () => ({ type: actionTypes.INTEGRATIONS_GET_CONNECTED_REQUEST });
export const getConnectedIntegrationsError = (payload) => ({ type: actionTypes.INTEGRATIONS_GET_CONNECTED_ERROR, payload });
export const getConnectedIntegrationsStore = (payload) => ({ type: actionTypes.INTEGRATIONS_GET_CONNECTED_STORE, payload });
export const getConnectedIntegrationsAllStore = (payload) => ({ type: actionTypes.INTEGRATIONS_GET_CONNECTED_ALL_STORE, payload });

export const disconnectIntegrationRequest = (payload) => ({ type: actionTypes.DISCONNECT_INTEGRATION_REQUEST, payload });
export const disconnectIntegrationError = (payload) => ({ type: actionTypes.DISCONNECT_INTEGRATION_ERROR, payload });
export const disconnectIntegrationStore = (payload) => ({ type: actionTypes.DISCONNECT_INTEGRATION_STORE, payload });

export const verifyIntegrationRequest = (payload) => ({ type: actionTypes.VERIFY_INTEGRATION_REQUEST, payload });
export const verifyIntegrationError = (payload) => ({ type: actionTypes.VERIFY_INTEGRATION_ERROR, payload });
export const verifyIntegrationSuccess = (payload) => ({ type: actionTypes.VERIFY_INTEGRATION_SUCCESS, payload });

export const authTwitterRequest = () => ({ type: actionTypes.AUTH_TWITTER_REQUEST });

export const instagramAddAccountRequest = (payload) => ({ type: actionTypes.INSTAGRAM_ADD_ACCOUNT_REQUEST, payload });
export const instagramAddAccountFailed = (payload) => ({ type: actionTypes.INSTAGRAM_ADD_ACCOUNT_ERROR, payload });
export const instagramAddAccountSucceed = (payload) => ({ type: actionTypes.INSTAGRAM_ADD_ACCOUNT_SUCCESS, payload });

export const instagramStoreAccountId = (payload) => ({ type: actionTypes.INSTAGRAM_STORE_ACCOUNT_ID, payload });

export const instagramVerifyAccountRequest = (payload) => ({ type: actionTypes.INSTAGRAM_VERIFY_ACCOUNT_REQUEST, payload });
export const instagramVerifyAccountFailed = (payload) => ({ type: actionTypes.INSTAGRAM_VERIFY_ACCOUNT_ERROR, payload });
export const instagramVerifyAccountSucceed = (payload) => ({ type: actionTypes.INSTAGRAM_VERIFY_ACCOUNT_SUCCESS, payload });

export const instagramCheckCodeRequest = (payload) => ({ type: actionTypes.INSTAGRAM_CHECK_CODE_REQUEST, payload });
export const instagramCheckCodeFailed = (payload) => ({ type: actionTypes.INSTAGRAM_CHECK_CODE_ERROR, payload });
export const instagramCheckCodeSucceed = (payload) => ({ type: actionTypes.INSTAGRAM_CHECK_CODE_SUCCESS, payload });

export const convertEmailRequest = (payload) => ({ type: actionTypes.CAMPAIGNS_CONVERT_EMAIL_REQUEST, payload });
export const convertEmailError = (payload) => ({ type: actionTypes.CAMPAIGNS_CONVERT_EMAIL_ERROR, payload });
export const convertEmailStore = (payload) => ({ type: actionTypes.CAMPAIGNS_CONVERT_EMAIL_STORE, payload });

export const instagramAccountReset = () => ({ type: actionTypes.INSTAGRAM_ACCOUNT_RESET });
export const storePosts = (payload) => ({ type: actionTypes.SET_STORE_POSTS, payload });
